export default "__VITE_ASSET__CSmCTTPZ__"